module.exports = __webpack_public_path__ + "d94eae17314f3f8ece3a25644f3b2dab.png";